import React, { useEffect, useContext } from "react";
import imageTools from "./ImageTools";
import {
  CanvasContext,
  ProductContext,
  ModuleContext,
  ImageContext,
} from "../provider";
import ff, { commonStyle } from "../../../util/fabric";

interface Images_prdProps {
  popArt?: boolean;
}

function Images_prd({ popArt }: Images_prdProps): JSX.Element {
  let t = window.INITIAL_DATA.TRANSLATIONS;
  const { printPaper } = useContext(ProductContext);
  const {
    moduleImages,
    setModuleImages,
    moduleInfo,
    setModuleInfo,
    setAreGridLinesEnabled,
    setIsFilteredImage,
  } = useContext(ModuleContext);
  const { productType } = useContext(ProductContext);
  const { canvasRef, scaledCanvasSize, canvasResizeCoef } = useContext(
    CanvasContext
  );
  const { initDropZone } = useContext(ImageContext);

  useEffect(() => {
    setAreGridLinesEnabled(true);
    setModuleInfo({
      ...moduleInfo,
      ...commonStyle,
    });
    initDropZone();
  }, []);

  // to set images
  useEffect(() => {
    let url = "https://storage.googleapis.com/papername-bucket";
    if (canvasRef.current && scaledCanvasSize) {
      let image = [];
      for (let i = 0; i < 9; i++) {
        /**
         * IMPORTANT NOTE: Do not change the id.
         * It is being used way to target object, especially number at the end.
         */
        let tempUrl = `${url}/presets/picture${
          productType === "pop-art" ? "-bw" : ""
        }.png`;

        image.push({
          id: `image-${i}`,
          originalUrl: tempUrl,
          filteredUrl: tempUrl,
          croppedUrl: tempUrl,
          renderUrl: tempUrl,
        });
      }
      setModuleImages([...image]);
      if (productType === "pop-art") setIsFilteredImage(true);
    }
  }, [canvasRef.current, scaledCanvasSize]);

  // to update images
  useEffect(() => {
    if (moduleImages && canvasRef.current) {
      let padding = ff.cmToPx(0.3, printPaper.dpi) * canvasResizeCoef;
      ff.handleImageOnly_ImageChange(
        moduleImages,
        canvasRef.current,
        false,
        padding,
        productType === "pop-art" ? true : false
      );
      canvasRef.current.renderAll();
      // @ts-ignore
      canvasRef.current.set({
        padding: padding,
      });
    }
  }, [moduleImages, scaledCanvasSize]);

  return (
    <imageTools.ImageUploader
      number={1}
      description={
        <p className={"product-section__description m-0 mb-3"}>
          {popArt ? t.upload_your_images_instructions_pop_art : t.upload_your_images_instructions}

        </p>
      }

    />
  );
}

export default Images_prd;
